













































import {Component, Vue} from 'vue-property-decorator';
import {emailRules, passwordRules} from '@/helpers/rules-validator';
import {forgotPassword, signIn} from '@/helpers/auth';

@Component({})
export default class Login extends Vue {

  form = {
    valid: false,
    email: '',
    password: '',
    loading: false,
  };

  get emailRules(): any[] {
    return emailRules(this.$t('rules.email.empty').toString(), this.$t('rules.email.format').toString());
  }

  get passwordRules(): any[] {
    return passwordRules(this.$t('rules.password.empty').toString(), this.$t('rules.password.length').toString());
  }

  forgotPassword(): void {
    forgotPassword(this.form.email.trim()).then(() => {
      this.$dialog.confirm({actions: [this.$t('close').toString()], text: this.$t('login.resetSent').toString(), title: this.$t('login.resetSentTitle').toString()});
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.unknown').toString(), title: this.$t('errors.error').toString()});
    });
  }

  doLogin(): void {
    if ((this.$refs.form as HTMLFormElement).validate()) {
      this.form.loading = true;

      signIn(this.form.email.trim(), this.form.password).then((isAdmin: boolean) => {
        this.form.loading = false;
        this.$router.push(isAdmin ? '/administration' : '/').catch(() => {
        });
      }).catch((err) => {
        this.form.loading = false;

        const invalid = err?.status === 401;
        const text = invalid ? this.$t('login.invalidCredentials').toString() : this.$t('errors.unknown').toString();
        this.$dialog.error({text, title: this.$t('errors.error').toString()});
      });
    }
  }
}
